import React from 'react'
import ProfileComponent from '../Components/Profile'

const Profile = () => {
  return (
    <ProfileComponent />
  )
}

export default Profile